import { render, staticRenderFns } from "./DevRoleSwitcher.vue?vue&type=template&id=5dfe97e6&scoped=true"
import script from "./DevRoleSwitcher.vue?vue&type=script&lang=js"
export * from "./DevRoleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DevRoleSwitcher.vue?vue&type=style&index=0&id=5dfe97e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe97e6",
  null
  
)

export default component.exports